export enum EnemyType {
   Bandit,
   Gobbo,
   Boss,
}

export enum BanditType {
   Scrapper,
   Fighter,
   Bruiser,
   Boss,
}

export enum GobboType {
   Runt,
   Warrior,
   Hunter,
   Caster,
   Brute,
   Chief,
}

export enum BossType {
   TheBaron,
   TheBeast,
   TheUgon,
}
